import { Component, Vue } from "vue-property-decorator";

@Component
export default class Refresh extends Vue {


  refresh(){

    localStorage.clear();

    window.location.assign('/login')

  }
  
}